import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChannelDirectorySmartCreateModal from './ChannelDirectorySmartCreateModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.channelDirectorySmartCreateModal.status,
  id: state.modal.channelDirectorySmartCreateModal.id,
  tags: state.tag.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_DIRECTORY_SMART_CREATE, { status: false, id: null }),
  createSmartDirectoryById: actions.storage.createSmartDirectoryById
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelDirectorySmartCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectorySmartCreateModal/index.js